module.exports = __webpack_public_path__ + "static/media/logo1.56914b55.png";